import Layout_admin from "./Layout_admin";
import GameList from "./game_list/GameList";
import Manager from "./manager";
import Notice from "./notice";
import CTL_LoadingScreen from "@/compo/CTL_LoadingScreen";

import game_setup_route from './game_setup/route';

export default [
  {
    path: "/admin",
    HydrateFallback: () => <CTL_LoadingScreen/>,
    element: <Layout_admin />,
    children: [
      {
        index: true,
        lazy: async () => {
          // await delay(1000)
          const compo = await import("./landing/Landing");
          return { Component: compo.default };
        },
      },
      
      { path:'manager', element:<Manager />},
      { path:'game-list', element:<GameList />},

      // 게임설정
      game_setup_route,

      { path:'notice', element:<Notice />},

    ],
  },
];

/*
export default [
  {
    index:true,
    lazy: async ()=>{
      // await delay(1000)
      const compo = await import('./IndexPage');
      return{ Component:compo.default }
    },
  },
  {
    path:'server',
    lazy: async ()=>{
      // await delay(1000)
      const compo = await import('./SetupServer');
      return{ Component:compo.default }
    },
  },
]
*/
